export function generateListenId() {
    return Math.round(Date.now() / 1000);
}
